import AdExposeTracker from './adExposeTracker'

export default {
  provide: function () {
    return {
      ad_expose_tracker: this.ad_expose_tracker
    }
  },
  data: function () {
    return {
      ad_expose_tracker: new AdExposeTracker({
        duration: 2000,
        effect_page: 'index'
      }),
      ad_expose_page_els: []
    }
  },
  created: function () {
    if (this.ad_expose_tracker && typeof this.adExposeEffectPage === 'function') {
      this.ad_expose_tracker.effect_page = this.adExposeEffectPage()
    }
  },
  activated: function () {
    if (this.ad_expose_tracker) {
      if (typeof this.adExposeEffectPage === 'function') {
        this.ad_expose_tracker.effect_page = this.adExposeEffectPage()
      }
      this.ad_expose_tracker.resume()
      this.syncRootInsetHandle(true)
      this.syncPopupAdExposeHandle()
    }
  },
  deactivated: function () {
    if (this.ad_expose_tracker) {
      this.ad_expose_tracker.pause()
      this.ad_expose_tracker.flush()
    }
  },
  beforeDestroy: function () {
    this.clearPageAdExposeHandle()
    if (this.ad_expose_tracker) {
      this.ad_expose_tracker.destroy()
    }
  },
  methods: {
    adExposeEffectPage: function () {
      return 'index'
    },
    observePageAdExposeHandle: function (el, flow_area, item) {
      if (!this.ad_expose_tracker || !el || !flow_area) return
      this.ad_expose_tracker.observe(el, flow_area, item)
      if (this.ad_expose_page_els.indexOf(el) < 0) this.ad_expose_page_els.push(el)
    },
    observePageAdExposeCarouselHandle: function (el, opt) {
      if (!this.ad_expose_tracker || !el || !opt) return
      this.ad_expose_tracker.observeCarousel(el, opt)
      if (this.ad_expose_page_els.indexOf(el) < 0) this.ad_expose_page_els.push(el)
    },
    clearPageAdExposeHandle: function () {
      if (!this.ad_expose_tracker) return
      var els = this.ad_expose_page_els || []
      for (var i = 0; i < els.length; i++) {
        this.ad_expose_tracker.unobserve(els[i])
      }
      this.ad_expose_page_els = []
    },
    resetAdExposeHandle: function () {
      if (!this.ad_expose_tracker) return
      this.ad_expose_tracker.flush()
      this.ad_expose_tracker.resetObserve()
      this.ad_expose_page_els = []
      if (typeof this.adExposeEffectPage === 'function') {
        this.ad_expose_tracker.effect_page = this.adExposeEffectPage()
      }
      this.syncPopupAdExposeHandle()
      this.syncRootInsetHandle(true)
    },
    bindPageAdExposeHandle: function () {
      var that = this
      this.clearPageAdExposeHandle()
      this.$nextTick(function () {
        that.bindInlineAdExposeHandle()
      })
    },
    bindInlineAdExposeHandle: function () {
      var tracker = this.ad_expose_tracker
      if (!tracker) return
      this.syncRootInsetHandle(true)
      var that = this
      var swiper_comp = this.$refs.bannerSwiper
      if (swiper_comp && swiper_comp.$el && this.newbannerlist && this.newbannerlist.length) {
        this.observePageAdExposeCarouselHandle(swiper_comp.$el, {
          get_index: function () {
            if (swiper_comp.swiper && typeof swiper_comp.swiper.realIndex === 'number') {
              return swiper_comp.swiper.realIndex
            }
            return that.activeIndex || 0
          },
          get_item: function (idx) {
            return that.newbannerlist[idx] || {}
          },
          make_key: function (idx) {
            return that.adExposeBannerKey(idx)
          }
        })
      }
      if (this.$refs.endorsementEl && this.mall_endorsement && this.mall_endorsement.img_path) {
        this.observePageAdExposeHandle(
          this.$refs.endorsementEl,
          this.adExposeCode('mall_endorsement', 0),
          this.mall_endorsement
        )
      }
      this.bindRefListAdExposeHandle('privatesphereEls', this.privatesphere, 'privatesphere')
      this.bindRefListAdExposeHandle('featuredEls', this.featuredads, 'ad')
      if (this.$refs.communityEl && this.communityad && this.communityad.img_path) {
        this.observePageAdExposeHandle(this.$refs.communityEl, this.adExposeCode('communityad', 0), this.communityad)
      }
      if (this.$refs.countdownEl && this.countdown && this.countdown.isshow > 0) {
        this.observePageAdExposeHandle(this.$refs.countdownEl, this.adExposeCode('countdown', 0), this.act_countdown || {})
      }
      if (this.$refs.privatefloatEl && this.privatefloat && this.privatefloat.img_path) {
        this.observePageAdExposeHandle(this.$refs.privatefloatEl, this.adExposeFloatCode(), this.privatefloat)
      }
      this.syncPopupAdExposeHandle()
      this.bindSeriesAdExposeHandle()
    },
    bindRefListAdExposeHandle: function (ref_name, list, prefix) {
      if (!list || !list.length) return
      var els = this.$refs[ref_name]
      if (!els) return
      if (!Array.isArray(els)) els = [els]
      for (var i = 0; i < els.length; i++) {
        if (els[i] && list[i]) {
          this.observePageAdExposeHandle(els[i], this.adExposeCode(prefix, i), list[i])
        }
      }
    },
    bindSeriesAdExposeHandle: function () {
      if (!this.serieslist || !this.serieslist.length) return
      var title_els = this.$el ? this.$el.querySelectorAll('.series .title img') : []
      for (var i = 0; i < title_els.length; i++) {
        var sitem = this.serieslist[i]
        if (sitem) {
          this.observePageAdExposeHandle(title_els[i], this.adExposeSeriesTitleCode(i), {
            ad_title: sitem.name,
            ad_type: '',
            ad_target: ''
          })
        }
      }
      var goods_els = this.$el ? this.$el.querySelectorAll('.series .seriesgoods .swiper-slide img') : []
      var gi = 0
      for (var s = 0; s < this.serieslist.length; s++) {
        var goods = this.serieslist[s].goodslist || []
        for (var g = 0; g < goods.length; g++) {
          if (goods_els[gi]) {
            this.observePageAdExposeHandle(goods_els[gi], this.adExposeSeriesGoodsCode(goods[g]), {
              ad_title: goods[g].name || '',
              ad_type: '3',
              ad_target: goods[g].item_id || ''
            })
          }
          gi++
        }
      }
    },
    adExposeCode: function (prefix, index) {
      return prefix + '-' + (index + 1)
    },
    adExposeBannerKey: function (idx) {
      return 'banner-' + (idx + 1)
    },
    adExposeFloatCode: function () {
      return 'mainfloat'
    },
    adExposeSeriesTitleCode: function (index) {
      return 'class-' + (index + 1)
    },
    adExposeSeriesGoodsCode: function (goods) {
      return 'classprod-' + (goods && goods.item_id ? goods.item_id : '')
    },
    syncPopupAdExposeHandle: function () {
      var tracker = this.ad_expose_tracker
      if (!tracker || typeof tracker.setKeyVisible !== 'function') return
      var show = !!(this.is_pop && this.popup_ads && this.popup_ads.img_path)
      tracker.setKeyVisible('indexpopup', show, this.popup_ads || {})
    },
    syncRootInsetHandle: function (force) {
      var tracker = this.ad_expose_tracker
      if (!tracker || typeof tracker.setRootInsetHandle !== 'function') return
      var now = Date.now()
      if (!force && this._ad_expose_inset_tick && now - this._ad_expose_inset_tick < 80) return
      this._ad_expose_inset_tick = now
      var top = 0
      var bottom = 0
      var header = this.$refs.header
      if (header && header.getBoundingClientRect) {
        var hr = header.getBoundingClientRect()
        if (hr.height > 0 && hr.bottom > 0) top = hr.bottom
      }
      var root = this.$el || (typeof document !== 'undefined' ? document : null)
      var footer = root && root.querySelector ? root.querySelector('.footer') : null
      if (footer && footer.getBoundingClientRect) {
        var fr = footer.getBoundingClientRect()
        var wh = window.innerHeight || document.documentElement.clientHeight || 0
        if (wh && fr.height > 0) bottom = Math.max(0, wh - fr.top)
      }
      tracker.setRootInsetHandle(top, bottom)
    },
    notifyBannerExposeHandle: function () {
      var swiper_comp = this.$refs.bannerSwiper
      if (swiper_comp && swiper_comp.$el && this.ad_expose_tracker) {
        this.ad_expose_tracker.onCarouselChange(swiper_comp.$el)
      }
    }
  },
  watch: {
    is_pop: function () {
      this.syncPopupAdExposeHandle()
    },
    isheaderwidth: function () {
      this.syncRootInsetHandle(true)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/homepage/js/adExposePageMixin.js